import { useEffect } from 'react';

const DEFAULT_TITLE = 'BrainWave Architectural Projects';
// Cache the original favicon href once on first load so we can restore it.
let __originalFaviconHref = null;
const getFaviconLink = () => {
  let link = document.querySelector("link[rel*='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  if (__originalFaviconHref === null) {
    __originalFaviconHref = link.getAttribute('href') || '/favicon.ico';
  }
  return link;
};

const buildFavicon = (color, letter) => {
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'>
    <rect width='64' height='64' rx='10' fill='${color}'/>
    <text x='50%' y='52%' dominant-baseline='middle' text-anchor='middle'
      font-family='-apple-system, system-ui, Segoe UI, sans-serif'
      font-size='38' font-weight='700' fill='white'>${letter}</text>
  </svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};

/**
 * useTabBranding — when active, sets a colored favicon + tab title prefix.
 * Restores the original on cleanup. Pass `null` to disable.
 *
 * Use case: signal at-a-glance which role the current admin tab is in (red
 * "ADMIN" for full admins, etc).
 */
export const useTabBranding = (preset) => {
  useEffect(() => {
    if (!preset) return undefined;

    const link = getFaviconLink();
    const prevTitle = document.title;
    const prevHref = link.getAttribute('href');

    document.title = `${preset.label} — ${DEFAULT_TITLE}`;
    link.setAttribute('href', buildFavicon(preset.color, preset.letter));

    return () => {
      document.title = prevTitle || DEFAULT_TITLE;
      link.setAttribute('href', __originalFaviconHref || prevHref || '/favicon.ico');
    };
  }, [preset?.label, preset?.color, preset?.letter]);
};

export const ROLE_PRESETS = {
  admin: { label: 'ADMIN', color: '#DC2626', letter: 'A' },     // red
  editor: { label: 'EDITOR', color: '#A16207', letter: 'E' },   // amber
};
